import { platformBrowser } from '@angular/platform-browser';
import { register } from 'swiper/element/bundle';
import 'bootstrap/dist/js/bootstrap.bundle.min.js';
import { AppModule } from './app/app-module';

register();

platformBrowser()
  .bootstrapModule(AppModule)
  .catch(error => console.error(error));
